import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import Rewards from '../components/rewards/Rewards';
import CondominiumRewards from '../components/condominium/rewards/CondominiumRewards';

// Misma URL para los dos roles: el propietario ve su propio programa
// (HO-TASK-282) y el administrador el resumen de su condominio (HO-TASK-288).
const RewardsHome = () => {
  const { role } = useSelector((state) => state.auth.user);
  return role === 'manager' ? <CondominiumRewards /> : <Rewards />;
}

const RewardsRoutes = ({ match: { url } }) =>
  <Switch>
    <ProtectedRoute exact path={`${url}`} rols={['property', 'manager']} component={RewardsHome} />
    <Redirect to="/errors/404" />
  </Switch>

RewardsRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(RewardsRoutes);
